import { render } from "./UploadLedger.vue?vue&type=template&id=41c00255&ts=true"
import script from "./UploadLedger.vue?vue&type=script&lang=ts"
export * from "./UploadLedger.vue?vue&type=script&lang=ts"

import "./UploadLedger.vue?vue&type=style&index=0&id=41c00255&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__